import { Box, Button, Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ManageAccountSection = function ManageAccountSection() {
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "ManageAccountSection",
    "data-source-file": "manage-account.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsxs(Box, {
        sx: {
          my: 4,
          display: 'flex'
        },
        children: [/*#__PURE__*/_jsxs(Box, {
          sx: {
            width: '70%'
          },
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h3",
            children: t('Manage my data')
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "caption",
            children: t('Request an export, change or deletion of your data by contacting support')
          })]
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            width: '30%',
            height: '50%',
            display: 'flex',
            justifyContent: 'flex-end'
          },
          children: /*#__PURE__*/_jsx(Button, {
            sx: {
              mt: 1
            },
            variant: "outlined",
            color: "primary",
            onClick: function onClick() {
              return window.open('https://influitive-supportdesk.zendesk.com/hc', '_blank');
            },
            children: t('Contact support')
          })
        })]
      });
    }
  });
};

export default ManageAccountSection;